/**
 * ### estimateFigureEm
 *
 * How wide a figure prints, in em of its own font, from its characters:
 * a tabular digit is a little over half an em, punctuation and spaces a
 * quarter to a third, a Hangul syllable nearly a full em. The sticky
 * counter has no way to shrink a figure to its column once it is printed,
 * and a figure that runs into the next column reads as broken, so the
 * column sizes the figure from this estimate before it prints. The
 * estimate errs wide: a figure a little smaller than it could be is no
 * harm, a figure a little too wide is the fault this exists to prevent.
 *
 * @param figure The figure exactly as the counter prints it, suffix included
 * @returns The estimated width in em
 */
export function estimateFigureEm(figure: string): number {
  const width = Array.from(figure).reduce((sum, char) => {
    if (/\d/.test(char)) return sum + 0.58;
    if (/[,.\s]/.test(char)) return sum + 0.27;
    if (char === '%') return sum + 0.83;
    if (char === '+') return sum + 0.58;
    if (/[ᄀ-ᇿ㄰-㆏가-힯一-鿿]/.test(char)) return sum + 0.88;
    if (/[A-Z]/.test(char)) return sum + 0.63;

    return sum + 0.52;
  }, 0);

  return Math.round(width * 100) / 100;
}
